import React from 'react'
import './testimonial.css'
import AVTR1 from '../../assets/avatar1.jpg'
import TestimonialAM from '../../assets/testimonial-AM.jpg'
import { TestimonialDatas } from './TestimonialData'

/*Swiper*/
import { Pagination } from 'swiper'
import {Swiper,SwiperSlide} from 'swiper/react'


import 'swiper/css';
import 'swiper/css/pagination';

const Testimonial = () => {
  return (
    <section id='testimonial'>
      <h5> Review of the work</h5>
      <h2>Testimonials</h2>

      <Swiper className='container testimonials__container' 
      modules={[Pagination]}
      spaceBetween={40}
      slidesPerView={1}
      pagination={{clickable:true}}
      >
        {/* {TestimonialDatas.map((item,index)=>{
          <SwiperSlide className='testimonial'>
          <div className='client__avatar'>
            <img src={AVTR1} alt="Avatar One"/>

          </div>

          <h5 className='client__name'>Ernest Achiever</h5>
            <small className='client__review'>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique repudiandae omnis deleniti rerum ratione eligendi ducimus eum animi, commodi, tempore a, nihil ullam fugit alias quae. Deserunt accusantium cum excepturi.
            </small>
        </SwiperSlide>
        })} */}
        
          <SwiperSlide className='testimonial'>
     
          <div className='client__avatar'>
            <img src={TestimonialAM} alt="Avatar One"/>

          </div>
          <a href='https://www.linkedin.com/in/abhishek-malik-84601515b/' target={'_blank'}>
          <h5 className='client__name'>Abhishek Malik : Worked in Isango</h5>
            <small className='client__review'>
            I enthusiastically recommend Anmol as a highly skilled and dedicated professional. Their proficiency in .Net and C# is exceptional, consistently delivering high-quality code solutions. Anmol excels in collaborative environments, actively contributing innovative ideas and demonstrating strong problem-solving abilities. Their reliability, attention to detail, and positive attitude make him a valuable asset to any development team.
            </small>
          </a>
        </SwiperSlide>
      
        
      </Swiper>
    </section>
  )
}

export default Testimonial